(function () {
  'use strict';

  // Evita instalar el listener más de una vez.
  if (window.__leveloutMindbodyTrackerInstalled) return;
  window.__leveloutMindbodyTrackerInstalled = true;

  // Widgets que representan una intención de compra.
  // healcode-link cubre el Cart V1 actual.
  // healcode-buy-now-popup cubre una posible migración a Cart V2.
  var widgetSelector = [
    'healcode-widget[data-type="pricing-link"] a.healcode-link',
    'healcode-widget[data-type="contract-link"] a.healcode-link',
    'healcode-widget[data-type="gift-card-link"] a.healcode-link',
    'healcode-widget[data-type="pricing-link"] a.healcode-buy-now-popup',
    'healcode-widget[data-type="contract-link"] a.healcode-buy-now-popup',
    'healcode-widget[data-type="gift-card-link"] a.healcode-buy-now-popup'
  ].join(',');

  function publishMindbodyEvent(payload) {
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      Shopify.analytics.publish('mindbody_add_to_cart', payload);
    } else if (window.console && typeof console.warn === 'function') {
      console.warn(
        '[Mindbody tracking] Shopify.analytics.publish no está disponible.'
      );
    }
  }

  function getClickTarget(event) {
    if (!event.target) return null;

    return event.target.nodeType === 1
      ? event.target
      : event.target.parentElement;
  }

  function getLinkText(link) {
    return (link.textContent || '').trim().slice(0, 100);
  }

  window.addEventListener('click', function (event) {
    var target = getClickTarget(event);
    if (!target || !target.closest) return;

    // Primero se comprueban los widgets. El return posterior evita que un
    // mismo clic pueda procesarse también como enlace directo.
    var widgetLink = target.closest(widgetSelector);

    if (widgetLink) {
      var widget = widgetLink.closest('healcode-widget');
      if (!widget) return;

      publishMindbodyEvent({
        source: 'mindbody_branded_web',
        link_origin: 'widget',
        detection: 'host_capture_widget_click',
        site_id: widget.getAttribute('data-site-id') || '',
        mb_site_id:
          widget.getAttribute('data-mb-site-id') ||
          widgetLink.getAttribute('data-mbo-site-id') ||
          '',
        item_id:
          widget.getAttribute('data-service-id') ||
          widgetLink.getAttribute('title') ||
          '',
        widget_type: widget.getAttribute('data-type') || '',
        link_text: getLinkText(widgetLink)
      });

      return;
    }

    // Si no fue un widget, se comprueba si es un enlace directo válido al
    // Private Site de Mindbody.
    var directLink = target.closest('a[href]');
    if (!directLink) return;

    var url;

    try {
      url = new URL(directLink.href, window.location.href);
    } catch (error) {
      return;
    }

    var productId =
      url.searchParams.get('prodId') ||
      url.searchParams.get('prodid');
    var studioId = url.searchParams.get('studioid');
    var saleType = url.searchParams.get('stype');

    // Filtro estricto para no medir enlaces de login, horarios o reservas.
    // stype=41 y stype=43 son los patrones de producto validados.
    if (
      url.protocol !== 'https:' ||
      url.hostname.toLowerCase() !== 'clients.mindbodyonline.com' ||
      url.pathname !== '/classic/ws' ||
      (saleType !== '41' && saleType !== '43') ||
      !productId
    ) {
      return;
    }

    publishMindbodyEvent({
      source: 'mindbody_private_site',
      link_origin: 'direct_link',
      detection: 'host_capture_direct_link',
      site_id: '',
      mb_site_id: studioId || '',
      item_id: productId,
      widget_type: 'classic-direct-link',
      link_text: getLinkText(directLink)
    });
  }, true); // true = capture phase
})();